import { RefObject } from 'react';

function waitForCanvas(
  ref: RefObject<HTMLDivElement | null>,
  timeout = 3000,
): Promise<HTMLCanvasElement | null> {
  return new Promise(resolve => {
    const start = Date.now();
    const poll = () => {
      const canvas = ref.current?.querySelector('canvas');
      if (canvas) {
        resolve(canvas as HTMLCanvasElement);
        return;
      }
      if (Date.now() - start > timeout) {
        resolve(null);
        return;
      }
      requestAnimationFrame(poll);
    };
    poll();
  });
}

const useQRCodeDownloader = () => {
  const downloadQRCode = async (ref: RefObject<HTMLDivElement | null>) => {
    const canvas = await waitForCanvas(ref);
    if (canvas) {
      const url = canvas.toDataURL();
      const a = document.createElement('a');
      a.download = 'QRCode.png';
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  return downloadQRCode;
};

export default useQRCodeDownloader;
